import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    index: 1,
};

const activeTileSlice = createSlice({
    name: "activeTileSlice",
    initialState,
    reducers: {
        increaseIndex: (state, active) => {
            state.index = state.index + 1;
            return state;
        },
        decreaseIndex: (state, action) => {
            state.index = state.index - 1;
            return state;
        },
        resetIndex: (state, action) => {
            state.index = 1;
            return state;
        }
    }
})
export const { increaseIndex, decreaseIndex, resetIndex } = activeTileSlice.actions;
export default activeTileSlice;